import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, MatTooltipModule],
    template: `
    @if (value() === true) {
      <mat-icon
        matTooltip="True"
        style="color:#4caf50; vertical-align:middle;"
        class="material-symbols-outlined"
        >
        check_circle
      </mat-icon>
    }
    
    @if (value() === false) {
      <mat-icon
        matTooltip="False"
        style="color:#f44336; vertical-align:middle;"
        class="material-symbols-outlined"
        >
        cancel
      </mat-icon>
    }
    
    @if (value() === null) {
      <mat-icon
        matTooltip="N/A"
        style="color:#9e9e9e; vertical-align:middle;"
        class="material-symbols-outlined"
        >
        remove_circle_outline
      </mat-icon>
    }
    `
})
export class ReportsListItemBooleanDisplay implements ICellRendererAngularComp {
  value = signal<boolean | null>(null);

  agInit(params: ICellRendererParams): void {
    this.value.set(this.normalize(params.value));
  }

  refresh(params: ICellRendererParams): boolean {
    this.value.set(this.normalize(params.value));
    return true;
  }

  private normalize(v: any): boolean | null {
    if (v === true || v === 'true' || v === 1 || v === '1') return true;
    if (v === false || v === 'false' || v === 0 || v === '0') return false;
    return null; // undefined, null, '', etc
  }
}